import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Weight } from './types/weight.enum';

import { IconColor } from '../icon/types/icon-color.types';
import { TypoColor } from './types/color.type';
import { TypoName } from './types/name.type';

@Component({
    selector: 'berry-typo',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './typo.component.html',
    styleUrl: './typo.component.scss',
})
export class TypoComponent implements OnChanges {
    @Input() isDelete: boolean = false;
    @Input() isPointer: boolean = false;
    @Input() weight: Weight = Weight._400;
    @Input() name: TypoName = 't1';
    @Input() color: TypoColor | IconColor = 'primary';
    @Input() customColor?: string;

    className!: string;

    constructor() {
        this.buildStyle();
    }

    ngOnChanges(changes: SimpleChanges): void {
        
        this.buildStyle();
    }

    buildStyle(): void {
        this.className = `weight-${this.weight} text__${this.name}`;
        if (!this.customColor) this.className += ` text-${this.color}`;
    }
}
